export default function makeDummyBlocker() {
    return {
        secureRequest(input) {
            return Promise.resolve(input);
        },
    };
}
